/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'pip-events',
    'window',
    'pip-model'

  ],
  function(
    pipEvents,
    window,
    pip
  ){
    function initEventListeners(){
      pipEvents.cart.addToCartAnalytics.on(function() {
          var digitalDataObject = {
            category: {
              primaryCategory: "stash"
            },
            eventInfo: {
              eventName: "cart addition info"
            },
            eventMode: "stash",
            stash: {
              component: "buybelt",
              pageType: "pip",
              target: "atc",
              item: [
                {
                displayPosition: "n/a",
                productInfo: {
                  sku: pip.products.primary.data.itemId,
                  customCatalog: window.digitalData.product[0].productInfo.customProduct
                }
              }
            ]
            }
          };
          pushAnalyticsEvent(digitalDataObject);
      });
    }

    function pushAnalyticsEvent(analyticsEventObject) {

      if (pip.debugMode) {
        console.log('DDO Add to Cart Event:', analyticsEventObject);
      }

      if (window.digitalData && window.digitalData.event) {
        window.digitalData.event.push(analyticsEventObject);
      }
    }

    return {
      init: function(){
        initEventListeners();
      }
    }
  });

}.call(window));